import z from 'zod';
import { productEntityFields } from './product-fields';

export const order = {
  checkoutId: z.string(),
  orderId: z.string(),
  orderNumber: z.string(),
  affiliation: z.string(),
  subtotal: z.number(),
  total: z.number(),
  revenue: z.number(),
  shipping: z.number().optional(),
  tax: z.number().optional(),
  discount: z.number().optional(),
  coupon: z.string().optional(),
  currency: z.string(),
  paymentMethod: z.string(),
  bank: z.string().optional(),
  products: z.array(z.object({ ...productEntityFields })).nonempty(),
};

export default {
  completed: z.object({
    ...order,
  }),
};
